import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Nav() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Servicios',
    href: '#servicios'
  }, {
    name: 'Nosotros',
    href: '#nosotros'
  }, {
    name: 'Contacto',
    href: '#contacto'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-negro/95 backdrop-blur-md shadow-md py-3' : 'bg-negro py-5'}`} data-id="element-155">
      <div className="max-w-[1180px] mx-auto px-5 md:px-8 flex justify-between items-center" data-id="element-156">
        <a href="#" className="flex items-center gap-3 group" data-id="element-157">
          <img src="https://cdn.magicpatterns.com/uploads/bnavR1u4tuUiwsyVXgDdfR/ISOTIPO_2_Black.png" alt="Quebrada Digital isotipo" className="h-10 md:h-12 w-auto transition-transform duration-250 group-hover:scale-105" data-id="element-158" />
          <span className="font-playfair text-ambar text-xl md:text-2xl font-bold tracking-wide" data-id="element-159">
            Quebrada Digital
          </span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8" data-id="element-160">
          <div className="flex gap-6" data-id="element-161">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-arena hover:text-ambar transition-colors duration-250 font-nunito text-base" data-id="element-162">
                {link.name}
              </a>)}
          </div>
          <a href="#contacto" className="bg-terracota text-white px-6 py-2.5 rounded-full font-nunito font-semibold hover:bg-terracota/90 transition-all duration-250 shadow-warm hover:shadow-warm-lg" data-id="element-163">
            Hablemos &rarr;
          </a>
        </div>

        {/* Mobile Toggle */}
        <button className="md:hidden text-arena p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-164">
          {isMobileMenuOpen ? <X size={24} data-id="element-165" /> : <Menu size={24} data-id="element-166" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-167">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="absolute top-full left-0 right-0 bg-negro border-t border-arena/10 shadow-xl md:hidden" data-id="element-168">
            <div className="flex flex-col p-5 gap-4" data-id="element-169">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-arena text-lg font-nunito py-2 border-b border-arena/5" data-id="element-170">
                  {link.name}
                </a>)}
              <a href="#contacto" onClick={() => setIsMobileMenuOpen(false)} className="bg-terracota text-white px-6 py-3 rounded-full font-nunito font-semibold text-center mt-2" data-id="element-171">
                Hablemos &rarr;
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}